module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0053.jpg?v=c8ed0a3c";